/** Shared display formatting for the Finance areas — one place, so every screen reads alike. */

const euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
const germanDate = new Intl.DateTimeFormat('de-DE');

export function money(value: number): string {
  // Negating a zero total yields -0, which Intl renders as "-0,00 €". Collapse it to a plain zero.
  return euro.format(value === 0 ? 0 : value);
}

export function dateLabel(value: string | null): string {
  return value ? germanDate.format(new Date(`${value}T00:00:00`)) : '–';
}

export function percent(value: number): string {
  return `${new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 }).format(value)} %`;
}

export function errorMessage(error: unknown): string {
  return error instanceof Error && error.message ? error.message : 'Der Vorgang konnte nicht verarbeitet werden.';
}
